import { z } from "zod";

export const ShippingProfileDtoSchema = z.object({
  autoRestore: z.boolean(),
  profileId: z.string(),
  profileName: z.string().nullish(),
  locationGroupId: z.string(),
  methodDefinitionId: z.string(),
  methodDefinitionConfig: z.any(),
  experienceId: z.string().uuid(),
  zoneId: z.string(),
  zoneName: z.string().nullish(),
});

export type ShippingProfileDto = z.infer<typeof ShippingProfileDtoSchema>;
